import { useRouter } from "next/router";
import { useState, useEffect, DependencyList } from "react";

export function useAnimeKeyWithDep({
  ext = "",
  deps = [],
  addRouterDeps = false,
}: {
  ext?: string;
  deps?: DependencyList;
  addRouterDeps?: boolean;
}): string {
  const { asPath, locale } = useRouter();
  const [animeKey, setAnimeKey] = useState<string>("");

  //idk if the following works, but it allowed removing the useAnimeKey function which was not used anywhere
  if (addRouterDeps) {
    deps = [asPath, locale, ...deps];
  }

  useEffect(() => {
    setAnimeKey(`${new Date().getTime()}-${ext}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return animeKey;
}
